import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CrmObjectService } from './crm-object-service/crm-object.service';
import { ObjectType } from '../../tokens-and-interfaces';

@Injectable()
export class CrmFieldOptionsService {
  constructor(private readonly objectService: CrmObjectService) {}

  getFieldOptions(fieldId: string, search: string, objectType: ObjectType): Observable<string[]> {
    return this.objectService
      .listFieldOptions(objectType, {
        fieldId: fieldId,
        pageSize: 10,
        searchTerm: search,
      })
      .pipe(map((response) => response?.options || []));
  }
}
